import { Card, CardContent } from '@/components/ui/card';
import { StatusBadge } from '@/components/common/StatusBadge';
import { ShipmentListItem } from '@/types/shipment.types';
import { formatDate } from '@/lib/formatters';
import { MapPin, User, DollarSign } from 'lucide-react';

interface ShipmentCardProps {
  shipment: ShipmentListItem;
  onClick: () => void;
}

export function ShipmentCard({ shipment, onClick }: ShipmentCardProps) {
  return (
    <Card
      className="cursor-pointer hover:shadow-md transition-all hover:border-primary animate-fade-in hover-scale"
      onClick={onClick}
    >
      <CardContent className="p-3 md:p-4">
        <div className="flex flex-col sm:flex-row sm:items-start justify-between mb-3 gap-2">
          <div className="min-w-0">
            <p className="font-semibold text-sm md:text-base mb-1.5 truncate">
              {shipment.tracking_number}
            </p>
            <StatusBadge status={shipment.status?.name_ || shipment.status?.code || ''} color={shipment.status?.color} />
          </div>
          <p className="text-xs text-muted-foreground flex-shrink-0">
            {formatDate(shipment.created_at)}
          </p>
        </div>

        <div className="space-y-2 text-xs md:text-sm">
          <div className="flex items-center gap-2 text-muted-foreground">
            <MapPin className="h-3 w-3 md:h-3.5 md:w-3.5 flex-shrink-0" />
            <span className="truncate">{shipment.address}</span>
          </div>

          <div className="flex items-center gap-2 text-muted-foreground">
            <User className="h-3 w-3 md:h-3.5 md:w-3.5 flex-shrink-0" />
            <span className="truncate">
              {shipment.recipient_name} - {shipment.recipient_phone}
            </span>
          </div>

          <div className="flex items-center gap-2 font-medium pt-1 border-t">
            <DollarSign className="h-3 w-3 md:h-3.5 md:w-3.5 flex-shrink-0 text-primary" />
            <span className="text-sm md:text-base">{shipment.total_amount}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
